import React, { useState } from 'react';
import { NextSeo } from 'next-seo';
import Layout from '~/components/Layouts/LayoutBasic/LayoutBasic';
// import Breadcrumb from '~/components/BreadcrumbNav/BreadcrumbNav';

import css from '~/styles/contact/contact.less';

const Business = () => {
  const [hotline] = useState({
    title: '客服热线',
    tel: '18600561983',
    msg: '工作时间：9:30 ~ 18:30',
  });

  const [data] = useState({
    title: '邮件联系',
    list: [
      {
        title: '商务合作：',
        msg: 'partner@xindebaby.com',
      },
      {
        title: '工作机会：',
        msg: 'career@xindebaby.com',
      },
    ],
  });

  return (
    <Layout>
      <NextSeo
        title="联系我们 - 新得宝贝"
        description="母婴服务放心选"
        additionalMetaTags={[
          {
            name: 'keywords',
            content: '新得宝贝,MUA孕育守护',
          },
        ]}
      />
      {/* <Breadcrumb title="联系我们" /> */}
      <div className={css.main}>
        <div className={css.sticky}>
          <div className={css.left}>
            <p className={css.pageTitle}>联系我们</p>
          </div>
        </div>
        <div className={css.box}>
          <p className={css.title}>
            {hotline.title}：{hotline.tel}
          </p>
          <p className={css.msg}>{hotline.msg}</p>
        </div>
        <div className={css.cont}>
          <p className={css.title}>{data.title}</p>
          <dl>
            {data.list.map((item, index) => {
              return (
                <React.Fragment key={index.toString()}>
                  <dt>{item.title}</dt>
                  <dd>{item.msg}</dd>
                  <hr className={css.br} />
                </React.Fragment>
              );
            })}
          </dl>
        </div>
      </div>
    </Layout>
  );
};

Business.getInitialProps = async ({ pathname, query, dvaStore }) => {
  // dispatch effects to fetch data here
  return {
    pathname,
    query,
    dvaStore,
  };
};

export default Business;
